import { Result } from "./common";

export interface SelectedMeal {
  mcdmicuid?: number;
  mcdHalfPortion?: boolean;
}

export interface MealCard {
  mcdfoluid: number;
  ilcshpid: number;
  ilcDate: string;
  selectedMeals: SelectedMeal[];
  mccText: string;
  mccLunchAshore: boolean;
  mccLunchCafe: boolean;
}

export interface SelectedMealsResponse {
  result: Result;
  mealCards: MealCard[];
}

export class GetSelectedMealsRequestBody {
  mcdfoluids?: number[];
  shpid?: number;
  ilcDate?: string;

  constructor(mcdfoluids?: number[], shpid?: number, ilcDate?: string) {
    this.mcdfoluids = mcdfoluids;
    this.shpid = shpid;
    this.ilcDate = ilcDate;
  }
}

export class SaveSelectedMealsRequestBody {
  mealCards?: MealCard[];

  constructor(mealCards?: MealCard[]) {
    this.mealCards = mealCards;
  }
}